import { PaymentMethod } from '@/sdk-api-v2/models';
import React from 'react'

interface PaymentMethodsProps {
    paymentMethods: PaymentMethod[];
}

interface BrandProps {
    url?: string;
    alt?: string;
}

export const PaymentMethodsComponent = ({ paymentMethods }: PaymentMethodsProps) => {
    const logoMap: {[key: string]: BrandProps} = {};

    for (let paymentMethod of paymentMethods) {
        if (paymentMethod.active) {
            switch (paymentMethod.code) {
                case 'credit_card':
                    ['visa', 'mastercard', 'elo', 'amex'].forEach(brand => {
                        logoMap[brand] = {url: `/images/payments/${brand}.svg`, alt: brand};
                    });
                    break;
                case 'pix':
                    logoMap[paymentMethod.code] = {url: '/images/payments/pix.svg', alt: paymentMethod.name};
                    break;
            }
        }
    }

    const allBrands = Object.values(logoMap);

    return (
        <div className='payment-methods-icons'>
            {allBrands.map((brand, index) => {
                return <img key={index} width="28" src={brand.url} alt={`Payment methods - ${brand.alt}`} title={brand.alt}></img>
            })}
        </div>
    );
}
